<template>
  <div id="contact" class="footer">
    <div class="footer-main">
      <div class="zy_constr">
        <div class="footer-logo__box">
          <img
            src="https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/bd00b18c-9870-4338-871e-457893b5c913.png"
            alt=""
            class="footer-logo"
          />
        </div>
        <div class="footer-scroll">
          <div class="footer-list">
            <div v-for="(item, index) in footerList" :key="index" class="footer-item">
              <div class="footer-item__title" @click="toggleFooterItem(index)">
                {{ item.module }}
                <span
                  class="footer-item__title-arrow"
                  :class="{ 'footer-item__title-arrow--active': expandedItems[index] }"
                ></span>
              </div>
              <template v-if="Array.isArray(item.list)">
                <div
                  v-for="(sub_item, sub_index) in item.list"
                  :key="sub_index"
                  class="footer-item__detail"
                  :class="{ 'footer-item__detail--expanded': expandedItems[index] }"
                >
                  <div class="footer-item__row">{{ sub_item.name || '' }}</div>
                  <div v-if="sub_item.phone" class="footer-item__row">电话：{{ sub_item.phone }}</div>
                  <div v-if="sub_item.wechat" class="footer-item__row">微信：{{ sub_item.wechat }}</div>
                  <div v-if="sub_item.email" class="footer-item__row">Email：{{ sub_item.email }}</div>
                </div>
              </template>
              <div
                v-else
                class="footer-item__detail"
                :class="{ 'footer-item__detail--expanded': expandedItems[index] }"
              >
                <div class="footer-item__row">{{ item.name || '' }}</div>
                <div v-if="item.phone" class="footer-item__row">电话：{{ item.phone }}</div>
                <div v-if="item.wechat" class="footer-item__row">微信：{{ item.wechat }}</div>
                <div v-if="item.email" class="footer-item__row">Email：{{ item.email }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-contact">
          <div class="footer-contact__item" v-for="item in CONTACT" :key="item.type">
            <div class="footer-contact__name" :style="{ backgroundImage: `url(${item.icon})` }">{{ item.name }}：</div>
            <div class="footer-contact__desc">{{ item.info }}</div>
          </div>
          <div class="footer-share">
            <template v-for="(item, index) in SHARE">
              <div
                v-if="item.qrcode"
                class="footer-share__item"
                :key="item.type"
                :style="{ backgroundImage: `url(${item.icon})` }"
              >
                <img :src="item.qrcode" alt="" class="footer-share__qrcode" />
              </div>
              <a
                v-else
                class="footer-share__item"
                :key="index"
                :href="item.href"
                target="_blank"
                :style="{ backgroundImage: `url(${item.icon})` }"
              >
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-policy">
      <div class="zy_constr">
        <div class="footer-policy__list footer-policy__list-top">
          <a v-for="(item, index) in POLICY" target="_blank" :key="index" :href="item.id" class="footer-policy__text">{{
            item.name
          }}</a>
        </div>
        <div class="footer-policy__list">
          <a v-for="(item, index) in ICP" target="_blank" :key="index" :href="item.href" class="footer-policy__text">{{
            item.name
          }}</a>
        </div>
        <div class="footer-policy__copyright">2025 All Rights Reserved 掌阅科技股份有限公司 版权所有</div>
      </div>
    </div>
  </div>
</template>

<script>
import { CONTACT, SHARE, ICP, POLICY } from '@/config';
import { Mixins } from '@ireader/core-lib';
export default {
  name: 'Footer',
  mixins: [Mixins.sdd()],
  data: function () {
    return {
      footerList: [],
      expandedItems: {}, // 存储每个footer项的展开状态
      CONTACT, // 联系方式
      SHARE,
      POLICY,
      ICP
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    /**
     * 获取合作伙伴列表数据
     */
    async getNewsList() {
      try {
        const res = await this.$getSdd('zycom/partners');
        this.footerList = res;
        // 初始化展开状态，所有项都收起
        this.footerList.forEach((item, index) => {
          this.$set(this.expandedItems, index, false);
        });
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * 切换footer项的展开/收起状态
     * 实现手风琴效果，最多只允许一个项展开
     * @param {number} index - footer项的索引
     */
    toggleFooterItem(index) {
      // 如果当前项已展开，则收起
      if (this.expandedItems[index]) {
        this.$set(this.expandedItems, index, false);
      } else {
        // 收起所有其他项
        Object.keys(this.expandedItems).forEach(key => {
          this.$set(this.expandedItems, key, false);
        });
        // 展开当前项
        this.$set(this.expandedItems, index, true);
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.footer-main {
  background-color: #031326;
  padding-top: 80px;
  padding-bottom: 40px;
}
.footer-logo__box {
  font-size: 0;
}

.footer-logo {
  width: 136px;
  height: 40px;
}

.footer-list {
  margin-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding-top: 40px;
  display: flex;
  flex-wrap: wrap;
}

.footer-item {
  width: 33.33%;
  margin-top: 16px;
  &:nth-child(-n + 3) {
    margin-top: 0;
  }
}
.M .footer-item {
  &:hover {
    .footer-item__detail {
      height: 72px;
    }
  }
}

.footer-item__title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  line-height: 24px;
  &-arrow {
    display: none;
  }
}

.footer-item__detail {
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.footer-item__row {
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
}

.footer-contact {
  margin-top: 40px;
  border-top: 1px solid #1c2b3c;
  padding-top: 40px;
  position: relative;
}

.footer-contact__item {
  display: flex;
  font-size: 14px;
  line-height: 18px;
  margin-top: 16px;
  &:first-child {
    margin-top: 0;
  }
}

.footer-contact__name {
  width: 75px;
  padding-left: 26px;
  background-size: 18px;
  background-repeat: no-repeat;
  color: #fff;
}

.footer-contact__desc {
  margin-left: 11px;
  color: rgba(255, 255, 255, 0.55);
  width: 221px;
}

.footer-share {
  display: flex;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.footer-share__item {
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 24px;
  position: relative;
  cursor: pointer;
  &:first-child {
    margin-left: 0px;
  }
  &:hover {
    .footer-share__qrcode {
      display: block;
    }
  }
}

.footer-share__qrcode {
  width: 176px;
  height: 176px;
  background-size: cover;
  position: absolute;
  left: -68px;
  top: -200px;
  display: none;
}

.footer-policy {
  height: 120px;
  background: #101519;
  padding: 16px 0;
  box-sizing: border-box;
}

.footer-policy__list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.footer-policy__text {
  margin-left: 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 22px;
  &:first-child {
    margin-left: 0;
  }
}

.footer-policy__copyright {
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 20px;
}

.S {
  .footer-main {
    padding: rem(72) 0;
    position: relative;
    &::after {
      content: '';
      display: inline-block;
      width: rem(65 * 3);
      height: rem(226 * 3);
      background: linear-gradient(90deg, rgba(3, 19, 38, 0.0001) 0%, #031326 100%);
      position: absolute;
      right: 0;
      top: rem(76 * 3);
    }
  }
  .footer-logo__box {
    text-align: center;
  }
  .footer-logo {
    width: rem(95 * 3);
    height: rem(84);
  }
  .footer-list {
    box-sizing: border-box;
    width: rem(900 * 3);
    margin-top: rem(72);
    padding-top: 0;
    border: none;
  }
  .footer-scroll {
    padding: 0 rem(48);
    width: rem(328 * 3);
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .footer-item {
    width: rem(282 * 3);
    margin-top: rem(48);
    margin-right: rem(72);
    &:nth-child(-n + 3) {
      margin-top: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &__title {
      font-size: rem(42);
      line-height: rem(54);
      &-arrow {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border: rem(16) solid transparent;
        border-top: rem(16) solid rgba(255, 255, 255, 0.55);
        vertical-align: middle;
        transition: transform 0.3s ease;

        // 展开时箭头旋转
        &--active {
          transform: rotate(180deg);
          transform-origin: center rem(9);
        }
      }
    }
    &__detail {
      font-size: rem(14);
      height: 0;
      overflow: hidden;
      transition: all 0.3s ease;
      &--expanded {
        height: rem(200);
      }
    }
    &__row {
      font-size: rem(36);
      line-height: rem(42);
      margin-top: rem(24);
    }
  }
  .footer-contact {
    margin: rem(72) rem(48) 0;
    padding-top: rem(75);
    &__item {
      font-size: rem(42);
      line-height: rem(54);
    }
    &__name {
      width: rem(96 * 3);
      padding-left: rem(78);
      background-size: rem(56);
    }
    &__desc {
      width: rem(663);
      line-height: rem(66);
      margin-left: rem(33);
    }
  }
  .footer-share {
    position: static;
    transform: none;
    margin-top: rem(72);
  }
  .footer-share__item {
    width: rem(108);
    height: rem(108);
    margin-left: rem(36);
    &:first-child {
      margin-left: 0;
    }
  }
  .footer-policy {
    height: rem(830);
    padding: rem(38 * 3) 0;
    &__text {
      font-size: rem(36);
      line-height: rem(66);
      margin-left: rem(48);
      color: rgba(255, 255, 255, 0.3);
    }
    &__copyright {
      font-size: rem(36);
      line-height: rem(66);
      color: rgba(255, 255, 255, 0.3);
    }
  }
  .footer-policy__list-top {
    margin-bottom: rem(99);
    .footer-policy__text {
      color: rgba(255, 255, 255, 0.7);
      margin-left: 0;
      &::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: rem(30);
        background: rgba(229, 229, 229, 0.1);
        margin: 0 rem(48);
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
